export const GET_ALL_PINCODEAREA_REQUEST = "GET_ALL_PINCODEAREA_REQUEST";
export const GET_ALL_PINCODEAREA_FAILURE = "GET_ALL_PINCODEAREA_FAILURE";
export const GET_ALL_PINCODEAREA_SUCCESS = "GET_ALL_PINCODEAREA_SUCCESS";

export const CREATE_PINCODEAREA_FAILURE = "CREATE_PINCODEAREA_FAILURE";
export const CREATE_PINCODEAREA_SUCCESS = "CREATE_PINCODEAREA_SUCCESS";
export const CREATE_PINCODEAREA_REQUEST = "CREATE_PINCODEAREA_REQUEST";

export const UPDATE_PINCODEAREA_REQUEST = "UPDATE_PINCODEAREA_REQUEST";
export const UPDATE_PINCODEAREA_FAILURE = "UPDATE_PINCODEAREA_FAILURE";
export const UPDATE_PINCODEAREA_SUCCESS = "UPDATE_PINCODEAREA_SUCCESS";

export const DELETE_PINCODEAREA_REQUEST = "DELETE_PINCODEAREA_REQUEST";
export const DELETE_PINCODEAREA_FAILURE = "DELETE_PINCODEAREA_FAILURE";
export const DELETE_PINCODEAREA_SUCCESS = "DELETE_PINCODEAREA_SUCCESS";